import * as angular from 'angular';

import { ComponentDefinition } from '../../../../models';
import { ChildApplicationComparison } from '../../../../services';

class ChildrenComparisonTableController implements angular.IComponentController {

    canUpdateAll: boolean;
    comparisonResult: ChildApplicationComparison[];
    hasOutOfDates: boolean;
    onUpdate: (value: { results: ChildApplicationComparison[] }) => angular.IPromise<ChildApplicationComparison[]>;

    $onChanges(changesObj: angular.IOnChangesObject) {
        if (changesObj['comparisonResult'] && this.comparisonResult) {
            this.canUpdateAll = this.comparisonResult.filter(s => s.canUpdate).length > 0;
        }
    }

    updateOne(item: ChildApplicationComparison) {
        if (this.onUpdate) {
            this.onUpdate({ results: [item] });
        }
    }

    updateAll() {
        if (this.onUpdate) {
            this.onUpdate({ results: this.comparisonResult.filter(d => d.isOutOfDate && d.canUpdate) });
        }
    }

    getTitle(comparison: ChildApplicationComparison) {
        return comparison.canUpdate
            ? 'Update child application'
            : comparison.message
                ? comparison.message
                : 'Engineer role is required to update child application';
    }
}

export const wtChildrenComparisonTable: ComponentDefinition = {
    componentId: 'wtChildrenComparisonTable',
    controller: ChildrenComparisonTableController,
    template: require('./childrenComparisonTable.component.html'),
    controllerAs: 'vm',
    bindings: {
        comparisonResult: '<',
        hasOutOfDates: '<',
        onUpdate: '&?'
    }
};
